module.exports = __webpack_public_path__ + "static/media/foodpanda.2b1de90e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/foodpanda.png
// module id = 271
// module chunks = 0